var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.1 3c4.471 0 8.1 3.629 8.1 8.1s-3.629 8.1-8.1 8.1A8.103 8.103 0 0 1 3 11.1C3 6.629 6.629 3 11.1 3m0 14.4c3.48 0 6.3-2.82 6.3-6.3s-2.82-6.3-6.3-6.3a6.3 6.3 0 0 0-6.3 6.3c0 3.48 2.819 6.3 6.3 6.3m7.637.064 2.546 2.545-1.274 1.274-2.545-2.547z"
  })));
};
export default SvgSearch;